<template>
  <!-- Auth list table -->
  <div
    class="bg-gray-50 shadow px-4 py-5 sm:rounded sm:p-6 min-h-screen overflow-hidden"
  >
    <!-- Header -->
    <div
      class="pb-5 border-b border-gray-200 sm:flex sm:items-center sm:justify-between"
    >
      <div class="sm:w-0 sm:flex-1">
        <h1 class="text-lg leading-6 font-medium text-gray-900">
          Authorization Request
        </h1>
        <p class="mt-1 text-sm text-gray-500 overflow-hidden overflow-ellipsis">
          This page displays a list of Authorization Requests that have been submitted through your attorney portal.    Authorization Requests cannot be made on matters that are designated with a plan class of REF (Referral only). If you do not know if the matter is a REF plan class, you can refer to the Case page, which will provide you with the plan class designation on that case. This information was also provided to you via the Assigned to Attorney email that you received on the case. To submit a new Authorization Request, please click the 'Request New Authorization' button in the top right-hand corner of the screen.
        </p>
      </div>
      <div class="mt-3 sm:mt-0 sm:ml-4">
        <router-link
          to="/create-authorization"
          type="button"
          class="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Request New Authorization
        </router-link>
      </div>
    </div>

    <div class="bg-white shadow sm:rounded-lg">
      <div class="px-4 py-5 sm:p-6">
        <form class="sm:flex sm:items-center" role="search" aria-label="Authorization request filters">
          <div class="w-half sm:max-w-xs mr-2">
            <label for="case_number" class="sr-only">USL Case Number</label>
            <input
              type="text"
              v-model="matter_number"
              name="mater_number"
              id="case_number"
              class="shadow-sm border-barley border-gray-300 block w-full sm:text-sm rounded-md"
              placeholder="USL Case Number"
            />
          </div>
          <div class="w-half sm:max-w-xs mr-2">
            <label for="member_number" class="sr-only">USL Member Number</label>
            <input
              type="text"
              v-model="member_number"
              name="member_number"
              id="member_number"
              class="shadow-sm border-barley border-gray-300 block w-full sm:text-sm rounded-md"
              placeholder="USL Member Number"
            />
          </div>
          <div class="w-auto sm:max-w-xs">
            <label for="status" class="sr-only">Status</label>
             <MultiSelect
              class="max-w-lg w-full shadow-sm sm:max-w-xs"
              v-model="status"
               display="chip"
               placeholder="Select Status"
              :options="statusList"
              optionLabel="name"
              inputId="status"
              aria-label="Status"
            />
          </div>
          <button
            type="button"
            v-on:click="search"
            class="mt-3 w-full inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm font-medium rounded-md text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
          >
            Search
          </button>
          <button
            type="button"
            v-on:click="clearSearch"
            class="mt-3 w-full inline-flex items-center justify-center px-4 py-2 border border-[#ba4224] shadow-sm font-medium rounded-md text-[#1f3341] bg-[#ffffff] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
          >
            Clear
          </button>
        </form>
      </div>
    </div>

    <div class="flex flex-col">
      <div class="-my-2 sm:-mx-6 lg:-mx-8">
        <div class="py-2 align-middle inline-block w-full sm:px-6 lg:px-8">
          <div
            class="shadow overflow-auto border-b border-gray-200 sm:rounded-lg"
          >
         <DataTable
              class="min-w-full divide-y divide-gray-200"
              :value="request_list"
              :paginator="true"
              :alwaysShowPaginator="false"
              :rowsPerPageOptions=[10,20,50,70,100]
              :rows="10"
            >
              <template #empty>
                No Records Found
              </template>
              <Column field="number" header="Matter#" :sortable="true">
              </Column>
              <Column
                field="member_name"
                header="Member"
                :sortable="true"
              ></Column>
              <Column
                field="coverage"
                header=" Subject/Coverage"
                :sortable="true"
              >
               <template #body="slotProps">
                  <div class="text-sm text-gray-900">{{ slotProps?.data?.subject }}</div>
                    <div class="text-sm text-gray-500">
                      {{ slotProps?.data?.coverage }}
                    </div>
               </template>
              </Column>
              <Column field="created_date" header="Created" :sortable="true">
                <template #body="slotProps">
                  {{ setDateFormat(slotProps?.data?.created_date) }}
                </template></Column
              >
              <Column field="status" header="Status" :sortable="true">
                <template #body="slotProps">
                  <span
                      v-if="slotProps?.data?.status == 'New'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800"
                    >
                      {{ slotProps?.data?.status }}
                    </span>
                    <span
                      v-if="slotProps?.data?.status == 'Open'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800"
                    >
                      {{ slotProps?.data?.status }}
                    </span>
                     <span
                     v-if="slotProps?.data?.sub_user_type != 'Attorney' && slotProps?.data?.status == 'Open'"
                      class="px-1 py-1 inline-flex text-xs font-semibold rounded-md bg-red-400 ml-1"
                    >
                    <i class="fa fa-bell-o" aria-hidden="true"></i>
                     </span>
                    <span
                      v-if="slotProps?.data?.status == 'Completed'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                    >
                      {{ slotProps?.data?.status }}
                    </span>
                </template>
              </Column>
              <Column header="Actions">
              <template #body="slotProps">
                 <router-link
                      :to="'/view-request/' + slotProps?.data?.id"
                      class="text-[#C04625] hover:text-indigo-500"
                    >
                      View Details
                    </router-link>
              </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="showPopup" class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full">
        <h2 class="text-center text-2xl font-semibold mb-4" style="color: #1f3341;">
          2025 Fee for Services Network Attorney Agreement
        </h2>
        <p class="text-gray-800 font-bold">
          We’re excited to share that U.S. Legal Services has updated and enhanced our Attorney Fee Reimbursement Schedule—designed with you in mind to offer greater overall compensation for the valuable work you do.<br />
          <br />
          The new schedule goes into effect on June 9, 2025. Please note that any matters authorized before that date will be paid based on the prior fee schedule, while all matters assigned and authorized on or after 9 will follow the updated rates outlined in the below link.<br />
          <br />
          Please click the following link to review and sign the new Fee for Services Network Attorney Agreement and Fee Schedule:
          <a  href="#"
          @click.prevent="handleFeeAgreementClick"
          class="text-blue-600 hover:underline">Click here</a>
        </p>
        <button @click="dismissPopup" class="mx-auto px-4 py-2 bg-[#1f3341] text-white rounded-lg hover:bg-[#1f3341] block">Close</button>
      </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Constants from "../../constants.ts"; // importing constant resubale variables.
import $ from "jquery";
import { checkFeeAgreementStatus, generateDynamicLink } from '@/utils/feeAgreementPopup';
export default {
  name: "AuthList",
  data() {
    return {
      showPopup: false,
      setDateFormat: Constants.setDateFormat,
      matter_number: "",
      member_number: "",
      status: "",
      statusList: [{ name: "New" }, { name: "Open" }, { name: "Completed" }],
    };
  },
  computed: {
  ...mapState(["request_list"]),
  attid() {
      return this.$store._state.data.att_user.data.id;
    },
  },
  async mounted() {
    const attid = this.attid || this.$store.state.profile_data.attid;
    const isSelected = await checkFeeAgreementStatus(this.$store);
    const dismissed = localStorage.getItem('feeAgreementPopupDismissed');
    this.showPopup = !isSelected && !dismissed;
    this.dynamicLink = await generateDynamicLink(attid);
  $("body, html").animate({ scrollTop: 0 }, 1000);
    this.$store.dispatch("getReqAuthorizations");
  },
  created() {
    this.$store.watch(
      () => this.$store.state.errors,
      (value) => {
        if (value != null) {
          if (value.message == "Authorization failed") {
            this.$toast.error(
              "Authorization Token Expired, Please login again!"
            );
            this.$store.dispatch("logout");
            setTimeout(() => {
              this.$router.push({ name: "Login" });
            }, 500);
          }
        }
      }
    );
  },
  methods: {
    dismissPopup() {
    this.showPopup = false;
    localStorage.setItem('feeAgreementPopupDismissed', 'true');
  },
    handleFeeAgreementClick() {

      // setTimeout(() => {
        // this.logoutUser();
        this.$store.dispatch("logout");

        // window.open(this.dynamicLink);
        window.location.href = this.dynamicLink;
      // }, 500);
    },
    clearSearch: function() {
      this.matter_number = null;
      this.member_number = null;
      this.status = "";
      this.$store.dispatch("getReqAuthorizations");
    },
    search: function() {
      console.log(this.status);
      this.$store.dispatch("getReqAuthorizations", {
        matter_number: this.matter_number,
        member_number: this.member_number,
        status: this.status,
      });
    },
  },
};
</script>
